import { memo, useEffect, useRef } from "react";
import PageContainer from "components/PageContainer";
import { motion } from "framer-motion";
import { Animations } from "const";
import useMount from "components/hooks/useMount";
import { signIn } from "redux/reducers/auth";
import { useDispatch, useSelector } from "react-redux";
import lottie from "lottie-web";
import animationData from "assets/json/lottie/scanning.json";
import IntlMessages from "components/Message/IntlMessages";
import styled from "styled-components";
import { AuthSelector } from "redux/selector";
import { LoggingAPI } from "services/logging-server";
import { DeviceUtil } from "utils/device-util";

const SSO = () => {
  const dispatch = useDispatch();
  const animation = useRef();
  const ssoError = useSelector(AuthSelector.ssoError);

  const params = new URLSearchParams(window.location.search);
  const authToken = params.get("code");
  const program = params.get("program");
  const channel = params.get("channel");

  useEffect(() => {
    if (supportsLottie()) {
      const anim = lottie.loadAnimation({
        animationData: JSON.parse(JSON.stringify(animationData)),
        container: animation.current,
        renderer: "svg",
        loop: true,
        autoplay: true,
      });

      anim.addEventListener("data_failed", async () => {
        try {
          await LoggingAPI.error({
            authToken,
            message: JSON.stringify({
              error: {
                message: "Lottie animation failed to load.",
              },
              deviceInfo: DeviceUtil.getDeviceInfo(),
            }),
          });
        } catch (_) {}
      });

      return () => anim.destroy();
    }
  }, [authToken]);

  useMount(() => {
    if (!authToken) {
      alert("No authenticator token specified.");
      return;
    }

    const payload = {
      authToken,
      program,
      channel,
      authType: "oauth",
    };

    dispatch(signIn(payload));
  });

  return (
    <PageContainer className="SSO">
      <Backdrop
        className="d-flex justify-content-center align-content-center"
        style={{ width: "100vw", height: "100vh" }}
      >
        {!ssoError && (
          <motion.div className="align-self-center" {...Animations.processing}>
            <div>
              <div ref={animation} style={{ height: 200, width: 200 }}></div>
              <Message className="text-center">
                <IntlMessages id="global.verifying" />
              </Message>
            </div>
          </motion.div>
        )}
      </Backdrop>
    </PageContainer>
  );
};

export default memo(SSO);

const Backdrop = styled(motion.div)`
  background-color: #fafafa;
`;

const Message = styled.h5`
  color: #3881b2;
`;

const supportsLottie = () => {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  return !!(window.AnimationEvent && context && context.drawImage);
};
